// extracted by mini-css-extract-plugin
export default {"aboutBg":"about_aboutBg__sPlg-"};